import React, { Component } from 'react'
import { Grid } from 'semantic-ui-react'
import { getMarkets } from 'services/Common'
import './FindUsContainer.less'
import _ from 'lodash'

class FindUsContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            markets: []
        }
    }

    componentDidMount = () => {
        this.loadData();
    }

    loadData = async () => {
        let marketRes = await getMarkets();
        if (marketRes.resStatus) {
            let markets = _.orderBy(marketRes.data, "name")
            this.setState({ markets: [...markets] })
        }
    }

    render() {
        return (
            <section className="find-us-section">
                <Grid className={"find-us-grid"}>
                    {
                        this.state.markets.length > 0 ?
                            this.state.markets.map((market) => {
                                return (
                                    <>
                                        <Grid.Column className={"find-us-col"}
                                            width={3}
                                            computer={3}
                                            mobile={8} tablet={5}
                                            key={"market-name-" + market.marketID}>
                                            {market.name}
                                        </Grid.Column>
                                    </>
                                )
                            })
                            :
                            <>
                                <Grid.Column>
                                    New York
                                </Grid.Column>
                                <Grid.Column>
                                    Houston
                                </Grid.Column>
                                <Grid.Column >
                                    San Antonio
                                </Grid.Column>
                                <Grid.Column >
                                    San Jose
                                </Grid.Column>
                                <Grid.Column >
                                    Fort Worth
                                </Grid.Column>
                                <Grid.Column >
                                    San Francisco
                                </Grid.Column>
                                <Grid.Column >
                                    Los Angeles
                                </Grid.Column>
                                <Grid.Column >
                                    Phoenix
                                </Grid.Column>
                                <Grid.Column >
                                    San Diego
                                </Grid.Column>
                                <Grid.Column >
                                    Austin
                                </Grid.Column>
                                <Grid.Column >
                                    Columbus
                                </Grid.Column>
                                <Grid.Column >
                                    Indianapolis
                                </Grid.Column>
                                <Grid.Column >
                                    Chicago
                                </Grid.Column>
                                <Grid.Column >
                                    Philadelphia
                                </Grid.Column>
                                <Grid.Column >
                                    Dallas
                                </Grid.Column>
                                <Grid.Column >
                                    Jacksonville
                                </Grid.Column>
                                <Grid.Column >
                                    Charlotte
                                </Grid.Column>
                                <Grid.Column >
                                    Seattle
                                </Grid.Column>
                            </>
                    }
                </Grid>
            </section>
        )
    }
}

export default FindUsContainer
